<template>
  <div class="article">
      <div class="article-wrap" id="articleWrap">
        <div class="detail-side-interaction">
          <!-- 分析 -->
          <div
            class="detail-icon"
            @click="openArticleInfo(articleInfo.articlesequenceid)"
          >
            <div><img :src="isClick ? iconUrl1 : iconUrl" />信息</div>
          </div>
          <!-- 原文 -->
          <div class="detail-icon" @click="jumpUrl">
            <!-- <el-tooltip class="item" effect="dark" content="原文" placement="right">
              <i class="icon-original"></i>
            </el-tooltip> -->
            <div><img src="../../../assets/jfrb/source.png"/>原网链接</div>
          </div>
          <!-- 信息 -->
          <transition name="fn-info-dialog">
            <div
              class="articleInfoDialog"
              v-click-outside="onClickOutside"
              v-if="InfoDialog && analysis"
            >
              <div class="fn-popper__arrow"></div>
              <el-scrollbar style="height: 400px">
                <div style="padding: 20px 40px 20px">
                  <div class="info-title" v-if="analysis.cls[0]">
                    <span
                      >{{ analysis.cls[0] }}
                      {{ toPercent(analysis.clsScore[0]) }}</span
                    >
                    <span
                      >{{ analysis.cls[1] }}
                      {{ toPercent(analysis.clsScore[1]) }}</span
                    >
                  </div>
                  <div class="list">
                    <ul>
                      <li
                        v-for="(item, index) in analysis.wordTriple"
                        :key="index"
                      >
                        {{ index + 1 }}、{{ item.key }}
                      </li>
                    </ul>
                  </div>

                  <!-- 正面百分比 -->
                  <div style="border-top:1px dashed #dedede;margin-top: 20px;">
                    <div class="secondary-title">
                      正面百分比：
                    </div>
                    <div>
                      <div class="progress-bar">
                        <div class="current-bar" ref="bar"></div>
                        <div class="tipVal" ref="tip1">
                          {{
                            this.analysis.sa == 10000
                              ? "100" + "%"
                              : (this.analysis.sa / 100).toFixed(2) + "%"
                          }}
                        </div>
                      </div>
                      <div class="progress-desc">
                        <div class="bad">负面</div>
                        <div class="neutral">中性</div>
                        <div class="good">正面</div>
                      </div>
                    </div>
                  </div>

                  <!-- 情感 -->
                  <div>
                    <div class="secondary-title">
                      情感：
                    </div>
                    <div class="bar-echarts-box">
                      <charts ref="chart" :option="optionBar" />
                    </div>
                  </div>

                  <!-- 人名 -->
                  <div v-if="analysis.nr">
                    <div class="secondary-title">
                      人名：
                    </div>
                    <div class="type-tag nr-tag">
                      <span
                        v-for="(item, index) in analysis.nr.trim().split(' ')"
                        :key="index"
                      >
                        {{ item }}</span
                      >
                    </div>
                  </div>

                  <!-- 地理 -->
                  <div v-if="analysis.ns">
                    <div class="secondary-title">
                      地理：
                    </div>
                    <div class="type-tag ns-tag">
                      <span
                        v-for="(item, index) in analysis.ns.trim().split(' ')"
                        :key="index"
                      >
                        {{ item }}</span
                      >
                    </div>
                  </div>

                  <!-- 组织 -->
                  <div v-if="analysis.nt">
                    <div class="secondary-title">
                      组织：
                    </div>
                    <div class="type-tag nt-tag">
                      <span
                        v-for="(item, index) in analysis.nt.trim().split(' ')"
                        :key="index"
                      >
                        {{ item }}</span
                      >
                    </div>
                  </div>

                  <!-- 核心词 -->
                  <div v-if="analysis.key">
                    <div class="secondary-title">
                      核心词：
                    </div>
                    <div class="type-tag key-tag">
                      <span
                        v-for="(item, index) in analysis.key.trim().split(',')"
                        :key="index"
                      >
                        {{ item }}</span
                      >
                    </div>
                  </div>
                </div>
              </el-scrollbar>
            </div>
          </transition>
        </div>
        <div class="article-title" v-html="handleTitle"></div>
        <div class="article-info">
          <span v-if="articleInfo.papername"
            >来源：{{ articleInfo.papername }}</span
          ><span>{{ articleInfo.updatetime }}</span>
        </div>
        <div>
          <div
            class="textWrap"
            ref="textWrap"
            v-html="brightenKeyword(articleInfo.contenttxt)"
          ></div>
        </div>
      </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import charts from "@/components/Charts.vue";
// import { GetAiQa } from "@/api/editorApi";
import { exec, objectUnique } from "../../../filters/index.js";
import { mapGetters } from "vuex";

export default {
  components: {
    charts,
  },
  props: {
    articleInfo: {
      type: Object,
      default: () => {},
    },
    analysis: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isClick: false,
      iconUrl: require("../../../assets/jfrb/info.png"),
      iconUrl1: require("../../../assets/jfrb/info-blue.png"),
      curEditIndex: 0,
      // analysis: {},
      InfoDialog: false,
      // articleInfo: {
        //   title: "建议将高中生22点就寝写入",
        //   updatetime: "2023-05-09 14:29",
        //   papername: "新华网",
        //   markinfo: "摘要",
        //   contenttxt:
        //     '<p style="margin-left:0px;text-align:justify;">4月8日上午，在金华市磐安县尖山镇乌石村，为期两天的“八八战略”在身边——“青马向上”研学营活动正式拉开帷幕。</p><p style="margin-left:0px;text-align:justify;">“青马向上”是参与活动的两个主体。“青马”是指浙江大学青年马克思主义者（学生骨干）培养学院（以下简称浙大“青马”），15年来累计培养了600余位优秀学员。“向上青年”则是磐安县2021年组建的青年活动团体，由小镇青年、机关青年、返乡创业青年、省市挂职青年、青年乡贤等群体组成。</p><figure class="image"><img src="https://rmrbcmsonline.peopleapp.com/upload/ueditor/image/20230409/a_829648368081825792.jpeg?x-oss-process=image/format,jpg/auto-orient,1" alt="image.png?x-oss-process=style/w10"></figure><p style="margin-left:0px;text-align:justify;">“我们希望浙大‘青马’学员们能够通过这次机会走进基层，多接触基层的干部群众，同时深入点位调研，为其发展建言献策。同时，这也为浙大学子跟地方青年创造了沟通交流的机会。”浙江大学团委兼职副书记、浙大“青马班”班主任徐本涛说。</p><p style="margin-left:0px;text-align:justify;">99年出生的张博文是磐安县委的一名年轻干部，但他已经充分感受到了基层工作的酸甜苦辣。“浙大的同学们想了解基层的故事，而我们又有提升理论水平的需求，正好可以‘互补’。”在张博文看来，作为山区26县之一的磐安需要更多活力的注入，才能焕发更夺目的光彩。</p><p style="margin-left:0px;text-align:justify;">8日下午，学员们来到尚湖镇，围绕工业经济、基层党建、新型农业和文旅产业四个主题开展调研。浙大“青马”将学员们分为四组，由青年社科学者带队，以问题为导向开展‘麻雀解剖式’调研。</p><p style="margin-left:0px;text-align:justify;">“基层究竟是怎么样的？”带着这样的疑问，浙江大学2020级本科生陈玥元跟随小组来到岭干村。刚入村，一条挂在村口处的红色条幅就吸引了她的注意，上面写着“岭干村村民三要：要团结、要勤奋、要争气”。</p><p style="margin-left:0px;text-align:justify;">尚湖镇党委副书记、岭干村第一书记王人骏开门见山，“这是我们的目标，说明我们现在还没有做到。今天就是希望大家来帮我们把把脉。”</p><p style="margin-left:0px;text-align:justify;">岭干村虽然文化底蕴丰富，有倪氏家庙、古花厅、造纸厂等遗存古迹，但是因为地处山区，人与地的矛盾一直制约着岭干村发展。王人骏告诉来调研的青年社科学者和学员们，“人与地的矛盾会逐步延伸到人与人的矛盾，以及景区与村庄的矛盾。”</p><p style="margin-left:0px;text-align:justify;">几年来，在省委宣传部的对口帮扶下，该村在村容村貌、产业发展、文化阵地建设上都取得了一定成绩。但口袋富了还不够，人心如何聚齐？</p><p style="margin-left:0px;text-align:justify;">该组的指导老师浙江大学团委副书记、“百人计划”研究员、博士生导师包大为指出，基层矛盾纠纷的划界和治理水平的提升，离不开党建引领。围绕这个话题，学员们在岭干村分头进行走访。</p><p style="margin-left:0px;text-align:justify;">陈玥元与小伙伴们将调研的重点放在了该村青年身上。听不懂方言，找不到合适的采访对象……一开始调研进行地并不顺利。陈玥元说，“没想到会遇到这么多问题”。但是他们没有轻易放弃，在村中走访的过程中终于遇到了一名愿意接受采访的95后。“在这里，我看到了最真实的基层，和当地村民的交流让我对书中学过的理论知识有了更加生动和具象的理解。” 陈玥元说。</p><figure class="image"><img src="https://rmrbcmsonline.peopleapp.com/upload/ueditor/image/20230409/1681039585998971.png?x-oss-process=style/w10" alt="image.png?x-oss-process=style/w10"></figure><p style="margin-left:0px;text-align:justify;">9日上午，在玉山古茶场，一场关于“八八战略”的大讨论正在火热展开。浙大“青马”学员与磐安“向上青年”自由组队，积极发表观点。</p><p style="margin-left:0px;text-align:justify;">“‘八八战略’是浙江开展主题教育的一大独特资源。青年们就‘八八战略’进行的讨论，都是用中国青年的方式讲述‘八八战略’的有益尝试。”浙江大学马克思主义学院青年教师赵永帅对青年们的表现做出了点评。</p><p style="margin-left:0px;text-align:justify;">“此次活动将宏观和微观结合了起来，基层实践加上理论学习，是一次立体化的学习体验。”陈玥元这样总结这次研学活动的感受。</p><p style="margin-left:0px;text-align:justify;">浙大“青马”与磐安“向上青年”共同签订“青马向上”合作备忘录，在本次研学营的基础上进一步深化校地合作。浙大“青马”在磐安设立实践调研点，为学员们提供实践调研的场域。磐安“向上青年”可以优先获得浙大学习培训机会，学术讲座信息资讯等。“青马向上 尚学守望”青年志愿服务驿站，则为求学中的磐安学子提供了定期与浙大“青马”学员交流的机会。</p>'
      // },
      val: "",
      optionBar: {
        grid: {
          top: "15%",
          left: "10%",
          right: "5%",
          bottom: "10%",
        },
        xAxis: {
          type: "category",
          data: [],
          // data: ["乐", "好", "怒", "哀", "惧", "恶", "惊"]
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            type: "bar",
            showBackground: true,
            barWidth: "30px",
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            data: [],
            // data: [120, 200, 150, 80, 70, 110, 130],

            itemStyle: {
              normal: {
                // color: "#26458e", //柱状颜色
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#7784A7" },
                  { offset: 0.2, color: "#7784A7" },
                  { offset: 1, color: "#959EB4" },
                ]),
                label: {
                  show: true, //开启数值显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#7784A7",
                    fontSize: 14,
                    fontWeight: "bold",
                  },
                },
              },
            },
          },
        ],
      },
      BrokeDownDialog: false,
      BrokeDownLoading: false, // 分析loading
      InfoLoading: false, // 信息loading
      Loading: false,
      BrokeDownList: null,
      //关键信息
      keyInfo: [],
      //事件概要
      eventSummary: "",
      //原因与措施
      reason: [],
      //地点
      location: [],
      BrokeDownfirst: false,
      //
      styleHeight: "470px",
      analysisProgress: 0,
      timer: null,
      divWidth: 612, // 初始宽度
      divHeight: 400, // 初始高度
      minWidth: 300, // 最小宽度
      minHeight: 200, // 最小高度
      isResizing: false, // 是否正在进行拉伸操作
      startX: 0, // 拉伸开始时的鼠标X坐标
      startY: 0, // 拉伸开始时的鼠标Y坐标
      pushData: [],
      isAdmin: false,
      imgList: [],
      isCollect: false,
      checkedCities: [],
      isIndeterminate: false,
      checkAll: false,
      ws: null, // WebSocket 对象
      messages: [], // 保存收到的消息
      isWs: true
    };
  },
  activated() {},
  updated() {
    // this.$refs.scrollContainer.wrap.scrollTop = 0;
  },
  watch: {
    articleInfo: {
      handler(val) {
        this.$refs.scrollContainer.wrap.scrollTop = 0;
        this.BrokeDownfirst = false;
        this.imgList = []
      },
      deep: true,
    },
    // analysisProgress:{
    //    handler(val) {
    //     this.analysisProgress = val;
    //   },
    //   deep: true,
    // }
  },
  computed: {
    // 处理标题字段为空时
    handleTitle() {
      let res = "";
      if (this.articleInfo.title) {
        res = this.fnColorChange(this.articleInfo.title);
      } else {
        res = "无标题";
      }
      return res;
    },
    ...mapGetters(["user", "codes" ]),
  },
  mounted() {
  },

  methods: {
    onClickOutside() {
      // 在这里处理点击区域以外的事件响应
      this.InfoDialog = false;
      this.isClick = false
    },
    openArticleInfo() {
      this.isClick = true
      setTimeout(() => {
        this.InfoDialog = true
        this.getAnalysis()
      }, 200);
    },
    // 获取文章信息详情数据
    getAnalysis() {
      setTimeout(() => {
        this.bar(); // 正面百分比进度条
        this.barEcharts();
      }, 500);
    },
    // 跳转原文
    jumpUrl() {
      window.open(this.articleInfo.url, "_blank");
    },
    bar() {
      this.$nextTick(() => {
        let progressBar = this.$refs.bar;
        progressBar.style.width = this.toPercent(this.analysis.sa);
        this.val = this.toPercent(this.analysis.sa);

        let progressTip = this.$refs.tip1;
        progressTip.style.left = this.toPercent(this.analysis.sa);
      });
    },
    // 转换为百分比
    toPercent(point) {
      var str = (point / 100).toFixed(2) + "%";
      return str;
    },

    // barEcharts 图表数据
    barEcharts() {
      if (this.optionBar.series[0].data == "") {
        this.$nextTick(() => {
          for (let i = 0; i < this.analysis.sa1.length; i++) {
            this.optionBar.xAxis.data.push(this.analysis.sa1[i].name);
            this.optionBar.series[0].data.push(this.analysis.sa1[i].score);
          }
          this.$refs.chart.drawChart();
        });
      } else {
        this.$nextTick(() => {
          this.optionBar.xAxis.data = [];
          this.optionBar.series[0].data = [];
          for (let i = 0; i < this.analysis.sa1.length; i++) {
            this.optionBar.xAxis.data.push(this.analysis.sa1[i].name);
            this.optionBar.series[0].data.push(this.analysis.sa1[i].score);
          }
          this.$refs.chart.drawChart();
        });
      }
    },

    fnColorChange(result) {
      let keys = [];
      // let keyStr = JSON.stringify(keys);

      keys.forEach((item) => {
        if (item) {
          let replaceReg = new RegExp(item, "gmi");
          let replaceString = `<span class="highlight">${item}</span>`;
          result = result.replace(replaceReg, replaceString);
        }
      });
      return result;
    },

    brightenKeyword(_html) {
      let keys = this.$store.getters["template/searchkeys"];
      if (_html) {
        keys.forEach((item, index) => {
          if (item) {
            var reg = new RegExp("(<[^>]*?)(" + item + ")([^<]*?>)", "gmi");
            var _htmlMatch = _html.match(reg);
            if (_htmlMatch) {
              _htmlMatch.forEach(function (element) {
                var newHtml = element.replace(
                  new RegExp(item, "gmi"),
                  "!@#whhxdd!@#"
                );
                _html = _html.replace(element, newHtml);
              });
            }
            _html = _html.replace(
              new RegExp(item, "gmi"),
              '<font class="highlight">' + item + "</font>"
            );
            _html = _html.replace(/!@#whhxdd!@#/gi, item);
          }
        });
      }
      return _html;
    },
  },

  directives: {
    "click-outside": {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // 判断是否在元素内部点击
          if (!(el == event.target || el.contains(event.target))) {
            // 如果不是，则触发回调函数
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      },
    },
  },
 
};
</script>

<style lang="scss">
.close {
  width: 32px;
  height: 32px;
  font-size: 24px;
  position: absolute;
  top: 10px;
  right: 10px;
  color: var(--text-tips);
  background: var(--bg);
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1;
  &:hover {
    color: var(--text-2);
    background: #f2f2f2;
  }
}
.article {
  width: 860px;
  margin: 0 auto;
  background-color: #fff;
  // border-left: 1px solid #ededed;
  // border-right: 1px solid #ededed;
  position: relative;
}
.article-wrap {
  position: relative;
  padding: 0 109px 160px;
}
.article-title {
  font-size: 24px;
  padding-top: 70px;
  padding-bottom: 10px;
  text-align: justify;
  font-weight: 600;
  color: var(--text-1);
  text-align: center;
}
.article-info {
  // display: flex;
  // justify-content: flex-start;
  // align-items: center;
  font-size: 13px;
  color: #7A7A7A;
  border-bottom: 1px solid var(--border-color);
  padding-top: 10px;
  text-align: center;
  // margin-bottom: 15px;
  span {
    margin-right: 15px;
  }
}
.markinfo {
  font-size: 14px;
  color: var(--text-3);
  margin-bottom: 15px;
  text-align: justify;
}
.textWrap {
  margin-top: 15px;
  video {
    width: 100%;
  }
  img {
    width: 100%;
    max-width: 100% !important;
    height: 100%;
    object-fit: cover;
    overflow: hidden;
    border-radius: 4px;
  }
  p {
    font-size: 16px;
    color: var(--text-1);
    line-height: 1.6;
    text-align: justify;
    margin-bottom: 15px;
  }
  .pic {
    margin-bottom: 15px;
    img {
      width: 100%;
      max-width: 100% !important;
      height: 100%;
      object-fit: cover;
      overflow: hidden;
      border-radius: 4px;
    }
    span {
      font-size: 12px;
      color: var(--text-3);
    }
  }
}

.textWrap .image img {
  display: block;
  margin: 0 auto;
  max-width: 100%;
  min-width: 50px;
}

.detail-side-interaction {
  position: absolute;
  height: 20px;
  right: 30px;
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  z-index: 2;
  .detail-icon {
    cursor: pointer;
    color: var(--text-2);
    &:hover {
      color: var(--red);
    }
    i {
      display: inline-block;
      width: 34px;
      height: 34px;
      background-size: 100%;
    }
    div {
      margin-right:20px;
      img {
        vertical-align: middle;
        margin-right: 6px;
        width: 12px;
        height: 12px;
      }
    }
    // span {
    //   font-size: 12px;
    //   line-height: 24px;
    // }
  }
}
.pushTtite {
  line-height: 14px;
  color: var(--text-2) !important;
  &:hover {
    color: var(--red) !important;
  }
}
.pushItem {
  color:#202D40FF;
  cursor: pointer;
  font-size: 13px;
  margin-bottom: 10px;
}
.pushItem:nth-child(4){
  margin-bottom: 0px;
}
.fn-popper__arrow {
  position: absolute;
  top: -5px;
  left: 66%;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 10px solid #fff;
  &:before {
    content: "";
    display: block;
    position: absolute;
    top: -13px;
    left: -5px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 10px solid #fff;
  }
}
.articleInfoDialog {
  position: absolute;
  top: 33px;
  // left: 50px;
  width:460px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  .info-title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;
    color: var(--text-1);
    span {
      margin-right: 20px;
    }
  }
  .list {
    ul {
      margin: 0;
      padding: 0;
      li {
        list-style-type: none;
        font-size: 12px;
        line-height: 1.5;
        color: var(--text-2);
        margin-bottom: 10px;
      }
    }
  }
}
.imgBox {
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  .imgItem{
    width: 31%;
    margin-right: 2%;
    height: 90px;
    margin-bottom: 15px;
    img {
      width:100%;
      height:100%;
      border-radius: 4px;
      object-fit: contain;
      cursor: pointer;
    }
  }
}
.progress-bar {
  width: 100%;
  height: 10px;
  border-radius: 2px;
  background-color: #f5f5f5;
  margin: 10px 0;
  position: relative;
  margin-top: 30px;
  .current-bar {
    position: absolute;
    left: 0;
    top: 0;
    height: 10px;
    border-radius: 2px;
    background: linear-gradient(to right, #52d5f6 0, #56cb41 100%);
    // animation: move 2s ease-in-out 0s 1 alternate forwards;
    width: 0;
    transition: width 1s ease-in-out;
  }
  .tipVal {
    width: 60px;
    position: absolute;
    transform: translateX(-30px);
    color: #fff;
    background: #56cb41;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    border-radius: 2px;
    position: relative;
    opacity: 0;
    animation: show 1s ease-in-out 0.5s 1 alternate forwards;
    &:after {
      content: "";
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid #56cb41;
      position: absolute;
      left: 50%;
      bottom: -5px;
      transform: translateX(-3px);
    }
  }
  &:before {
    content: "";
    width: 2px;
    height: 24px;
    background: linear-gradient(
      0deg,
      rgba(23, 124, 42, 0) 0%,
      rgba(23, 124, 42, 1) 50%,
      rgba(23, 124, 42, 0) 100%
    );
    display: block;
    position: absolute;
    left: 44.5%;
    z-index: 1;
    top: 50%;
    transform: translateY(-12px);
  }
  &:after {
    content: "";
    width: 2px;
    height: 24px;
    background: linear-gradient(
      0deg,
      rgba(23, 124, 42, 0) 0%,
      rgba(23, 124, 42, 1) 50%,
      rgba(23, 124, 42, 0) 100%
    );
    display: block;
    position: absolute;
    left: 54.5%;
    z-index: 1;
    top: 50%;
    transform: translateY(-12px);
  }
}
@keyframes show {
  from {
    opacity: 0;
    top: -10px;
  }
  to {
    opacity: 1;
    top: -28px;
  }
}
// @keyframes move {
//   from {
//     width: 0%;
//   }
//   to {
//     width: 100%;
//   }
// }
.progress-desc {
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .bad,
  .good {
    text-align: center;
    flex: 1;
    position: relative;
    color: var(--fw-text-1);
  }
  .bad {
    &::before {
      content: "0%";
      position: absolute;
      left: 0;
      color: var(--text-3);
    }
    &::after {
      content: "45%";
      position: absolute;
      right: 0;
      color: var(--text-3);
    }
  }
  .good {
    &::before {
      content: "55%";
      position: absolute;
      left: 0;
      color: var(--text-3);
    }
    &::after {
      content: "100%";
      position: absolute;
      right: 0;
      color: var(--text-3);
    }
  }
  .neutral {
    width: 10%;
    text-align: center;
    color: var(--text-1);
  }
}
.bar-echarts-box {
  width: 100%;
  height: 200px;
  display: block;
}
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
.type-tag {
  margin-top: 5px;
  span {
    font-size: 14px;
    padding: 4px 6px;
    border-radius: 2px;
    margin-right: 4px;
    margin-bottom: 10px;
    display: inline-block;

    color: #568de5;
    background: #ecf4ff;
  }
}
.secondary-title {
  font-size: 14px;
  color: var(--text-1);
  margin-top: 15px;
}
.fn-info-dialog-enter-active {
  animation: fn-fade-in 0.3s;
}
.fn-info-dialog-leave-active {
  animation: fn-fade-in 0.3s reverse;
}
@keyframes fn-fade-in {
  0% {
    opacity: 0;
    transform: translateY(-4%);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.related-news {
  line-height: 1.5;
  margin-top: -15px;
  h5 {
    font-weight: normal;
    color: var(--text-2);
    padding: 5px 0;
    border-bottom: 1px solid var(--border-color);
    font-weight: 600;
  }
  i{
    display: inline-block;
    float: left;
    height: 13px;
    line-height: 19px;
    font-style: normal;
    margin-right: 5px;
  }
  i::before{
    content: "\2022";
    font-size: 20px;
    // background: var(--text-2);
  }
}
.reading {
  color: var(--text-tips);
  font-size: 12px;
  margin-top: 5px;
  span {
    color: var(--text-1);
  }
}
.highlight {
  color: rgb(255, 51, 44);
  // background-color: #fffcf2;
  padding: 2px;
}
.icon-article-character {
  width: 16px;
  height: 16px;
  display: inline-block;
  // background: url("~@/assets/smart/icon-character.svg") no-repeat center center;
  background-size: 100%;
}
.icon-article-event {
  width: 16px;
  height: 16px;
  display: inline-block;
  // background: url("~@/assets/smart/icon-event.svg") no-repeat center center;
  background-size: 100%;
}
.icon-article-reason {
  width: 16px;
  height: 16px;
  display: inline-block;
  // background: url("~@/assets/smart/icon-reason.svg") no-repeat center center;
  background-size: 100%;
}
.icon-article-location {
  width: 16px;
  height: 16px;
  display: inline-block;
  // background: url("~@/assets/smart/icon-location.svg") no-repeat center center;
  background-size: 100%;
}
.icon-star-on {
  width: 14px;
  height: 14px;
  display: inline-block;
  // background: url("~@/assets/smart/collect.svg") no-repeat center 1px;
  background-size: 100%;
}
.character-t,
.event-t,
.reason-t,
.location-t {
  display: flex;
  align-items: center;
  span {
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #202d40;
    margin-left: 5px;
  }
}
.character-item {
  .character-c {
    padding-left: 17px;
    div {
      width: 100%;
      // height: 80px;
      background: #f4f6f8;
      border-radius: 2px;
      padding: 10px;
      margin-top: 10px;
      font-family: PingFangSC-Medium, PingFang SC;
      .characterName {
        font-size: 15px;
        color: #202d40;
        font-weight: 600;
      }
      .characterPosition {
        font-size: 12px;
        color: #202d40;
        font-weight: 400;
        margin-top: 10px;
      }
    }
  }
}
.event-item,
.reason-item {
  margin-top: 24px;
  .event-c,
  .reason-c {
    margin-top: 10px;
    .enent-c-i {
      display: flex;
      padding-left: 22px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #202d40;
      line-height: 1.5;
    }
    .reason-c-i {
      margin-bottom: 20px;
      div {
        display: flex;
        padding-left: 22px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #202d40;
        line-height: 1.5;
        span {
          min-width: 36px;
          display: inline-block;
        }
        p {
          max-width: 90%;
        }
      }
    }
  }
}
.location-item {
  margin-top: 24px;
  .location-c {
    margin-top: 10px;
    .location-c-i {
      display: flex;
      padding-left: 22px;
      .left-l {
        display: flex;
        align-items: center;
        margin-top: 2px;
        span {
          width: 10px;
          height: 1px;
          background: #202d40;
          display: inline-block;
        }
      }
      .right-l {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #202d40;
        margin-left: 5px;
      }
    }
  }
}
.refer {
  // position: absolute;
  // right: 0px;
  // bottom: 0px;
  width: 100%;
  height: 50px;
  background: #fff;
  overflow: hidden;
  div {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5386d7;
    cursor: pointer;
    line-height: 50px;
    float: right;
    margin-right: 28px;
  }
}
.nov {
  max-height: 470px;
}
// .nov::-webkit-scrollbar {
//   display: none;
// }
.resizableDialog {
  position: absolute;
  top: -100px;
  left: 50px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  resize: both;
  overflow: auto;
  min-width: 300px;
  min-height: 150px;
}
.resizableDialog::-webkit-scrollbar {
  width: 4px;
}
.resizableDialog::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
}
.resizableDialog::-webkit-scrollbar-track {
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.moreItem {
  cursor: pointer;
}
.moreItem:nth-child(1){
  margin-bottom: 10px;
}
.moreItem:nth-child(1)::before{
  right: 30px;
  top: 3px;
}
.confirm{
  margin-left: 40px;
  color:#5386D7;
  cursor: pointer;
}

</style>
